import { TRegionSummary } from '../../../../../wowretail/src/frontend/scripts/libs/store';

export function generateRealmLocationOptionValue({
  region,
  realm
}: {
  region: TRegionSummary;
  realm: { slug?: string; name?: string };
}) {
  if (!realm.slug && !realm.name) {
    return undefined;
  }

  return `${region.slug.toUpperCase()}-${realm.name || realm.slug}`;
}
